import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Content from "./Content/container";

export type MapProps = RootContainerProps & {
  agentId: string;
  isEditMode: boolean;
};
export default (props: MapProps) => {
  if (!props.agentId && !props.isEditMode) return null;

  return (
    <Container className="wsc_content_ai_chats" {...getContainerProps(props)}>
      {props.agentId ? <Content {...getRootContainerProps(props)} /> : "Please select an agent in the settings"}
    </Container>
  );
};
